import type { ReactElement, ReactNode } from "react"
import type { UseFormReturn } from "react-hook-form"

import { Form } from "@/components/forms/Form"
import { TextField } from "@/components/forms/TextField"
import { Textarea } from "@/components/forms/Textarea"
import type { LicenseData } from "@/hooks/useLicenseStore"

type TextFieldProps = Parameters<typeof TextField>[0]
type TextareaProps = Parameters<typeof Textarea>[0]

type RequirementField =
  | {
      kind: "text"
      name: TextFieldProps["name"]
      label?: TextFieldProps["label"]
      description?: TextFieldProps["description"]
      inputProps?: TextFieldProps["inputProps"]
    }
  | {
      kind: "textarea"
      name: TextareaProps["name"]
      label?: TextareaProps["label"]
      description?: TextareaProps["description"]
      textareaProps?: TextareaProps["textareaProps"]
    }

type RequirementDetailsSectionProps = {
  form: UseFormReturn<LicenseData>
  fields: RequirementField[]
  beforeFields?: ReactNode
}

export const RequirementDetailsSection = ({
  form,
  fields,
  beforeFields
}: RequirementDetailsSectionProps): ReactElement => {
  return (
    <Form form={form}>
      {beforeFields}
      {fields.map(field => {
        if (field.kind === "text") {
          return (
            <TextField
              key={field.name}
              form={form}
              name={field.name}
              label={field.label}
              description={field.description}
              inputProps={field.inputProps}
            />
          )
        }

        return (
          <Textarea
            key={field.name}
            form={form}
            name={field.name}
            label={field.label}
            description={field.description}
            textareaProps={field.textareaProps}
          />
        )
      })}
    </Form>
  )
}
